export enum EdsEntityCodes {
  Account = 'Account',
  Accounts = 'Accounts',
  AccountNotification = 'AccountNotification',
  Address = 'Address',
  Addresses = 'Addresses',
  AddressTypes = 'AddressTypes',
  AddressType = 'AddressType',
  AssignmentQueue = 'AssignmentQueue',
  Assignee = 'Assignee',
  AssignmentQueueMemberships = 'AssignmentQueueMemberships',
  ClaimSet = 'ClaimSet',
  Insured = 'Insured',
  Beneficiary = 'Beneficiary',
  Beneficiaries = 'Beneficiaries',
  Person = 'Person',
  Party = 'Party',
  PersonAddress = 'PersonAddresses',
  BusinessAddress = 'BusinessAddresses',
  Business = 'Business',
  ContactInformation = 'ContactInformation',
  RequestedDocument = 'RequestedDocument',
  DocumentType = 'DocumentType',
  Document = 'DocumentEntity',
  Documents = 'Documents',
  DocumentEntityVersion = 'DocumentEntityVersion',
  DocumentEntityVersions = 'DocumentEntityVersions',
  DocumentVersion = 'DocumentVersion',
  DocumentVersions = 'DocumentVersions',
  DocumentInstance = 'DocumentInstance',
  DocumentInstances = 'DocumentInstances',
  CorrespondenceItems = 'CorrespondenceItems',
  CorrespondenceSet = 'CorrespondenceSet',
  Correspondences = 'Correspondences',
  Correspondence = 'Correspondence',
  ClaimEntity = 'ClaimEntity',
  ClaimEntities = 'ClaimEntities',
  Claim = 'Claim',
  Policy = 'Policy',
  Contact = 'Contact',
  Contacts = 'Contacts',
  Tasks = 'TaskEntity',
  TaskEntities = 'TaskEntities',
  TaskType = 'TaskType',
  Coverage = 'Coverage',
  ClaimCoverage = 'ClaimCoverage',
  ClaimCoverages = 'ClaimCoverages',
  Claimant = 'Claimant',
  Claimants = 'Claimants',
  BeneficiaryContacts = 'BeneficiaryContacts',
  RequestedItem = 'RequestedItem',
  RequestedItems = 'RequestedItems',
  RequestedData = 'RequestedData',
  RequestedDataType = 'RequestedDataType',
  ClaimSetPolicyMatch = 'ClaimSetPolicyMatch',
  Roles = 'Roles',
  Milestone = 'Milestone',
  Producer = 'Producer',
  ProducerGroup = 'ProducerGroup',
  Note = 'Note',
  NotificationType = 'NotificationType',
  EntityRecentActivity = 'EntityRecentActivity',
  BenefitCalculation = 'BenefitCalculation',
  AddressHistory = 'AddressHistory',
  Benefit = 'Benefit',
  PaymentSchedule = 'PaymentSchedule',
  Payment = 'Payment',
  PaymentMethod = 'PaymentMethod',
  PaymentMethods = 'PaymentMethods',
  Payee = 'Payee',
  Adjustments = 'Adjustments',
  Adjustment = 'Adjustment',
  PaymentAdjustment = 'PaymentAdjustment',
  BenefitAdjustments = 'BenefitAdjustments',
  BenefitAdjustment = 'BenefitAdjustment',
  BillingHistory = 'BillingHistory',
  SLA = 'SLA',
  Transaction = 'Transaction',
  Transactions = 'Transactions',
  CreatedByPerson = 'CreatedByPerson',
  Reviewers = 'Reviewers',
  Reminder = 'Reminder',
  UsersToRemind = 'UsersToRemind',
  PaymentSplits = 'PaymentSplits',
  PaymentSplit = 'PaymentSplit',
  MailingAddress = 'MailingAddress',
  HelperTag = 'HelperTag',
  HelperTags = 'HelperTags',
  AvailableHelperTags = 'AvailableHelperTags',
  ClaimCoverageBenefitCalculationValue = 'ClaimCoverageBenefitCalculationValue',
  DecisionTable = 'DecisionTable',
  Relationship = 'Relationship',
}
